import { AnimatePresence, motion } from "framer-motion";

/**
 * NOTE: This is a copy of the flicket-ui version, will be replaced when the ui is updated to the latest version.
 */

/**
 * Function to animate the reveal of children components.
 *
 * Intended for use within forms or sections where content visibility
 * needs to be toggled with a smooth animation.
 */
export function AnimateReveal({
  children,
  show,
  durationMulitplier = 1,
  initial = false,
  delay = 0,
  ...props
}: {
  children: React.ReactNode;
  show: boolean;
  durationMulitplier?: number;
  initial?: boolean;
  delay?: number;
}) {
  const duration = 0.3 * durationMulitplier;
  return (
    <AnimatePresence initial={initial}>
      <motion.div
        initial="collapsed"
        animate={show ? "open" : "collapsed"}
        variants={{
          open: {
            opacity: 1,
            height: "auto",
            transition: {
              delay,
              opacity: { duration: duration / 3 },
              height: { duration: duration, ease: [0.04, 0.62, 0.23, 0.98] },
            },
          },
          collapsed: {
            opacity: 0,
            height: 0,
            transition: {
              opacity: { duration: duration / 3 },
              duration: duration,
              ease: [0.04, 0.62, 0.23, 0.98],
            },
          },
        }}
        style={{ overflow: "hidden" }}
        {...props}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
